<template>
   <div>
      <div class="row p-2 mt-4">
         <div class="col-12">
            <span class="custom-span-lg" style="color: #435666;">Configuration
               <i class="fa-solid fa-arrow-right"></i>
            </span>
            <span class="custom-span-no-weight" style="color: #435666;"> &nbsp;Extension Keys</span>
            <div class="mt-2">
               <small class="text-muted">
                  <i class="fa-solid fa-puzzle-piece me-1" style="color: #00A0C1;"></i>
                  Manage browser extension keys allocated to this account.
               </small>
            </div>
         </div>
      </div>

      <ExtensionKeys />
   </div>
</template>

<script>
import ExtensionKeys from '@/components/ExtensionConfiguration/Extension Keys/ExtensionKeys.vue';

export default {
   components: {
      ExtensionKeys,
   },
}
</script>

<style scoped>
.custom-span-lg { font-size: 24px; line-height: 24px; font-weight: bold; }
.custom-span-no-weight { font-size: 24px; line-height: 24px; font-weight: 250; }
</style>